var map = {
	"./agromat.webp": "b1e0",
	"./agrosem.webp": "0769",
	"./arcmet.webp": "29a7",
	"./budpostach.webp": "8eb0",
	"./centra.webp": "4933",
	"./eva.webp": "a0ea",
	"./gs.webp": "a29f",
	"./hc.webp": "0079",
	"./metinvest.webp": "9474",
	"./mhp.webp": "7da7",
	"./rud.webp": "7c91",
	"./shedro.webp": "a54f",
	"./sirius.webp": "35bd",
	"./terra.webp": "67a6",
	"./tpk.webp": "fe35",
	"./ufc.webp": "a795",
	"./varus.webp": "c8cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "39c1";